import { FILE_TYPES } from '@frontend/design-system';
import { PreviewAssetKind } from '../types';

export const PREVIEW_KIND_BY_MIME_TYPE: Partial<Record<string, PreviewAssetKind>> = {
  [FILE_TYPES.pdf]: 'pdf',
  [FILE_TYPES.mp4]: 'video',
  [FILE_TYPES.png]: 'image',
  [FILE_TYPES.jpg]: 'image',
  [FILE_TYPES.jpeg]: 'image',
  [FILE_TYPES.docx]: 'docx',
};

export const getAssetType = (asset: PreviewAssetKind): string => {
  for (const [key, value] of Object.entries(PREVIEW_KIND_BY_MIME_TYPE)) {
    if (value === asset) {
      return key;
    }
  }
  return '';
};

export const getAssetKind = (mimeType?: string): PreviewAssetKind => {
  if (mimeType) {
    const exactKind = PREVIEW_KIND_BY_MIME_TYPE[mimeType];

    if (exactKind) {
      return exactKind;
    }
    const mimeTypeLowerCase = mimeType?.toLocaleLowerCase();

    if (mimeTypeLowerCase.startsWith('image/')) {
      return 'image';
    }

    if (mimeTypeLowerCase.startsWith('video/')) {
      return 'video';
    }
  }
  // Default to 'image' if the mimeType is not recognized or not provided
  return 'image';
};

export const getReadableFileExtension = (type?: string, url?: string): string | undefined => {
  // TODO: add support or video
  for (const [key, value] of Object.entries(FILE_TYPES)) {
    if (type === value || url?.toLocaleLowerCase().endsWith(key)) {
      return key.toUpperCase();
    }
  }

  return undefined;
};

export const canPreview = (asset?: PreviewAssetKind): boolean => {
  // TODO: add support or video
  return asset ? asset === 'image' || asset === 'pdf' : false;
};
